// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50835847","396":"24a2e079","453":"cc5644b1","455":"26f08cee","977":"f57ce9c5"}[chunkId] + ".chunk.js";
};